import { Controller } from '@hotwired/stimulus';

/**
 * checkbox 활성화 여부에 따라 date-picker를 활성화/비활성화
 * - 활성화시 -> 현재 날짜 (yyyy.MM.dd. HH:00)
 * - 비활성화시 -> empty
 */

export default class extends Controller {
  static targets = ['toggle', 'picker'];

  connect() {
    this.toggleTarget.addEventListener('change', this.toggle.bind(this));
    if (this.toggleTarget.checked) {
      for (const i in this.pickerTargets) {
        this.pickerTargets[i].disabled = 'disabled';
        this.pickerTargets[i].value = '';
      }
    }
  }

  toggle(e) {
    for (const i in this.pickerTargets) {
      if (e.target.checked) {
        this.pickerTargets[i].disabled = 'disabled';
        this.pickerTargets[i].value = '';
      } else {
        this.pickerTargets[i].disabled = '';
        this.pickerTargets[i].value = this.getDefaultDate();
      }
    }
  }

  // 'yyyy.MM.dd. HH:00'
  // view/meet/fragment/datetime.html 참조
  getDefaultDate() {
    const date = new Date();
    return `${date.getFullYear()}.${('0' + (date.getMonth() + 1)).slice(-2)}.${date.getDate()}. ${date.getHours()}:00`;
  }
}
